export enum StatusIntegracaoScanntechEnum {
  NaoIdentificado = 0,
  Valido = 1,
  Invalido = 2,
  MarcadoParaReprocessamento = 3,
  PendenteEnvio = 4,
}
